import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private authService: AuthService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authService.isAuthenticated()) {
      const userRole = this.authService.getRole()
      if (route.data.roles && route.data.roles.indexOf(userRole) === -1) {
        this.router.navigate(['/dashboard']);
        return false;
      }

      return true;
    }
    this.router.navigate(['/account/login'], { queryParams: { redirect: state.url }, replaceUrl: true });
    return false;
  }

}